<template lang="html">
    <section class="new-50-img" v-if="dataContent">
        <router-link :to="{
        name: 'page-entry',
        params: {
          typeContent: this.dataContent.type,
          slug: this.dataContent.slug,
        },
      }" class="content-new" title="Enlace a la noticia">
            <img :src="dataContent.image.url" :alt="dataContent.image_footer" class="img-new" />

            <div class="info-box">
               
                <h2><Markdown v-if="this.dataContent.name_markdown" class="title" :source="this.dataContent.name_markdown" /></h2>
                <p class="box-dates">
                    <span class="date-text">{{ currentDateTime(dataContent.publish_date) }} </span>
                    <span class="author" v-if="dataContent.source">{{dataContent.source}}</span>

                    <template v-for="theme in dataContent.themes" :key="theme.id">
                        <span class="category-tag">{{ theme.name }}</span>
                    </template>
                    <span class="category-location" v-if="dataContent.zone">
                        {{ dataContent.zone.name }}
                    </span>
                </p>
                <p>
                    {{cutText(dataContent.header ,200) }}
                </p>
            </div>
        </router-link>
    </section>
</template>

<script lang="js">
    import moment from 'moment';
    import Markdown from 'vue3-markdown-it';
    export default {
        name: 'new-50-img',
        props: ['dataContent'],
        components: {
            Markdown
        },
        methods: {
            currentDateTime(date) {
                return moment(date).locale('es').format('L')
            },
        },
        computed: {
            typeContent() {
                switch (this.dataContent.type) {
                    case 'entry':
                        return 'noticia'
                    case 'opinion':
                        return 'opinion'
                    case 'interview':
                        return 'entrevista'
                    case 'coverage':
                        return 'reportaje'
                    case 'event':
                        return 'evento'
                    case 'media':
                        return 'multimedia'
                    default:
                        return 'noticia'
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/colours.scss";

    .new-50-img {
        padding: 20px 0 20px 0;
        cursor: pointer;

        /* border-bottom: 1px solid $blueLight; */
        .content-new {
            text-decoration: none;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            height: 100%;
            /* max-height: 300px; */
            position: relative;
            border-radius: 13px;
            padding-left: 10px;

            .category {
                position: absolute;
                left: 0px;
                top: 10px;
                z-index: 2;
                background: $orange;
                font-weight: 900;
                color: white;
                font-size: 16px;
                padding: 5px 15px;
                border-radius: 13px;
            }

            .img-new {
                width: 50%;
                border-radius: 13px;
                height: auto;
                object-fit: cover;
                object-position: center;
                height: 235px;
            }

            .info-box {
                width: 50%;
                padding: 0 20px;

                .title,
                .title p {
                    font-size: 27px;
                }
            }
        }
    }

    @media screen and (max-width:845px) {
        .new-50-img .content-new .info-box .title {
            font-size: 18px;
        }

        .subtitle {
            font-size: 16px;
        }

        .new-50-img .content-new {
            flex-wrap: wrap;
        }

        .new-50-img .content-new .img-new {
            width: 100%;
            margin-bottom: 10px;
        }

        .new-50-img .content-new .info-box {
            width: 100%;
            padding: 0;
        }

        .new-50-img .content-new {
            padding-left: 0;
        }
    }
</style>